import { createStore as reduxCreateStore, applyMiddleware, combineReducers } from 'redux';
import logger from 'redux-logger';
import * as modules from './model/redux/modules';
const createStore = () => {
    const store = reduxCreateStore(combineReducers({
        item: modules.Item.default,
        adminUser: modules.AdminUser.default,
    }), applyMiddleware(logger));
    return store;
};
export default createStore();
